import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useBreadcrumbs } from '../../Routes/BreadcrumbContext';
import { createBreadcrumbs } from '../../utils/breadcrumbUtils';
import CandidatosEdicaoList from './CandidatosEdicaoList';

const CandidatosEdicao: React.FC = () => {
    const { processoId } = useParams<{ processoId: string }>();
    const { setBreadcrumbs } = useBreadcrumbs();

    useEffect(() => {
        setBreadcrumbs(createBreadcrumbs.fromProcessos([
            { path: `/processos/${processoId!}/candidatos/upload`, breadcrumb: 'Gerenciar Candidatos' },
            { path: `/processos/${processoId!}/candidatos/editar`, breadcrumb: 'Editar Candidatos' },
        ]));
    }, [setBreadcrumbs, processoId]);

    return (
        <div className="container mt-4">
            <CandidatosEdicaoList processoId={processoId!} />
        </div>
    );
};

export default CandidatosEdicao;